import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DATE_FORMAT } from "../constants/ConstantsKey";
import _ from "lodash";
import * as Storage from "../utils/storage";
import { storageKeys } from "../constants/storage";

dayjs.extend(utc);

export const isDateExpiredUTC = (dateStr) => {
    if (!dateStr) return false;
    try {
        const expiryDate = dayjs.utc(dateStr).format('YYYY-MM-DD');
        const todayUTC = dayjs.utc().format('YYYY-MM-DD');
        return expiryDate < todayUTC;
    } catch (e) {
        return false;
    }
};

export const showFormatDate = (date) => {
    if (dayjs.isDayjs(date)) {
        date = dayjs(date.$d || date);
    } else {
        date = dayjs(date);
    }
    if (!date.isValid()) {
        return "Invaild Date";
    }

    return date.format(DATE_FORMAT);
}

//Follow Flow Tailwind Responsive
export const antdResponsive = (settings = { xxs: {}, xs: {}, sm: {}, md: {}, lg: {}, xl: {} }) => {
    const responsive = [];
    if (!_.isEmpty(settings.xxs)) {
        responsive.push({
            breakpoint: 439,
            settings: settings.xxs,
        })
    }

    if (!_.isEmpty(settings.xs)) {
        responsive.push({
            breakpoint: 639,
            settings: settings.xs,
        })
    }

    if (!_.isEmpty(settings.sm)) {
        responsive.push({
            breakpoint: 767,
            settings: settings.sm,
        })
    }

    if (!_.isEmpty(settings.md)) {
        responsive.push({
            breakpoint: 1023,
            settings: settings.md,
        })
    }

    if (!_.isEmpty(settings.lg)) {
        responsive.push({
            breakpoint: 1279,
            settings: settings.lg,
        })
    }

    if (!_.isEmpty(settings.lx)) {
        responsive.push({
            breakpoint: 1535,
            settings: settings.xl,
        })
    }

    return responsive;
}

export const objectToQuery = (uri, obj) => {
    const cleanedObj = _.omitBy(obj, value => value === null || value === undefined || value === '' || value === false || Number.isNaN(value));

    return `${uri}?` + Object.keys(cleanedObj).map(key => key + '=' + cleanedObj[key]).join('&');
};

export const formatReadingTime = (time) => {
    if (!time) return ' 分钟';
    
    const timeStr = String(time);
    if (timeStr.includes(' 分钟')) {
        return timeStr;
    }
    
    return `${timeStr} 分钟`;
};

export const stripHtml = (html) => {
    if (!html) return "";
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
};